import { LuSearch } from 'react-icons/lu';

interface SearchProps {
    searchTerm: string;
    searchPlaceholder: string;
    onSearchChange: (term: string) => void;
}

export const Search: React.FC<SearchProps> = ({ onSearchChange, searchPlaceholder, searchTerm }) => (
    <div className="flex gap-2 h-8 items-center overflow-hidden px-3 border-b border-b-grey-outline-light border-l-0 border-r-0 border-t-0 border-solid">
        <LuSearch className="size-4 text-midnight shrink-0" />
        <input
            type="text"
            size={1}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            autoFocus
            className="min-w-0 w-full font-normal font-roboto text-sm leading-[1.46] text-midnight opacity-80 outline-none placeholder:opacity-80"
        />
    </div>
);

Search.displayName = 'Search';
